import type { ShortcutDefinition } from '../types';

/**
 * 全 hotkey の SSOT（docs/agentic-session-impl-plan.md §4.3 shortcuts）。
 *
 * registry 経由（useShortcut）で実配線したものだけを登録する。追加時は衝突検査
 * （validateRegistry.test.ts）+ FORBIDDEN_KEY_COMBOS の確認が必須。
 */
export const SHORTCUT_DEFINITIONS = [
// ============ global ============
{
  id: 'shortcuts.help',
  keys: {
    mac: 'meta+/',
    win: 'ctrl+/'
  },
  scope: 'global',
  labelKey: 'features.shortcuts.actions.shortcutsHelp'
}, {
  // 開発者用の日英トグル。動作は useToggleLanguage（lib/i18n）、listener は registry。
  // GlobalShortcuts（__root）で useShortcut 配線。NEW_FEATURE フラグでガードし、
  // 一覧では開発者ツールセクションに表示する。Win キーは実機確認まで暫定
  id: 'lang.switch',
  keys: {
    mac: 'ctrl+meta+l',
    win: 'ctrl+alt+l'
  },
  scope: 'global',
  labelKey: 'features.shortcuts.actions.langSwitch',
  featureFlag: 'NEW_FEATURE',
  developer: true
}] as const satisfies readonly ShortcutDefinition[];
export type ShortcutId = (typeof SHORTCUT_DEFINITIONS)[number]['id'];
const SHORTCUT_DEFINITION_MAP: ReadonlyMap<ShortcutId, ShortcutDefinition> = new Map(SHORTCUT_DEFINITIONS.map(definition => [definition.id, definition]));
export function getShortcutDefinition(id: ShortcutId): ShortcutDefinition {
  const definition = SHORTCUT_DEFINITION_MAP.get(id);
  if (!definition) {
    throw new Error(`Unknown shortcut id: ${id}`);
  }
  return definition;
}